import { computed, ref, unref, watch } from 'vue';
import { fetchInlineSvgMarkup, isSvgUrl } from 'shared/helpers/inlineSvg';

export const useInlineSvg = urlSource => {
  const svgMarkup = ref('');
  const loadFailed = ref(false);

  const resolvedUrl = computed(() => unref(urlSource) || '');
  const isSvg = computed(() => isSvgUrl(resolvedUrl.value));

  let abortController = null;

  watch(
    resolvedUrl,
    async url => {
      abortController?.abort();
      svgMarkup.value = '';
      loadFailed.value = false;

      if (!url || !isSvgUrl(url)) return;

      abortController = new AbortController();

      try {
        svgMarkup.value = await fetchInlineSvgMarkup(url, {
          signal: abortController.signal,
        });
        if (!svgMarkup.value) loadFailed.value = true;
      } catch (error) {
        if (error.name !== 'AbortError') loadFailed.value = true;
      }
    },
    { immediate: true }
  );

  return { isSvg, svgMarkup, loadFailed };
};
